/* eslint-disable indent */
import React, { useReducer } from 'react'

const reducer = (state, action) => {
  switch (action.type) {
    case 'OPEN_AUTH':
      return { ...state, authed: true }
    case 'CLOSE_AUTH':
      return { ...state, authed: false }
    default:
      return state
  }
}

const initialState = {
  authed: !!localStorage.getItem('token'),// this params is a possible solution to show or hide elements in navbar
}

const AppContext = React.createContext(initialState)

function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState)

  return (
    <AppContext.Provider value={{ state, dispatch }}>
      {children}
    </AppContext.Provider>
  )
}

export { AppContext, AppProvider }
